<div class="flex flex-col gap-medpace">
    <a (click)="downloadExpenseReport()">Download expense report</a>
    <div class="flex flex-col gap-medpace">
        @for (expense of request().reimbursementTransactions; track $index) {
            <medpace-expense-view [expense]="expense" [index]="$index" />
        }
    </div>
    <mds-divider />
    <div class="grid grid-cols-3 gap-medpace px-medpace">
        <div>
            <h5 class="font-bold">Date Requested</h5>
            <span>{{ request().createdTimestamp?.toDate() | dateFormat | uppercase }}</span>
        </div>
        <div>
            <h5 class="font-bold">Date Submitted</h5>
            <span>
                @if (request().submittedTimestamp) {
                    {{ request().submittedTimestamp?.toDate() | dateFormat | uppercase }}
                } @else {
                    Request was not submitted yet
                }
            </span>
        </div>
    </div>

    @let elevatedAccess = elevatedAccess$ | async;

    @if (elevatedAccess) {
        @if (isInProcessOrHigher$ | async) {
            <div class="grid grid-cols-3 gap-medpace px-medpace">
                <!--  only display TotalAuthorized in the request's total currency for requests that have not undergone post-currency conversion migration -->
                @if (isPreCurrencyConversionMigration()) {
                    <div>
                        <h5 class="font-bold">Total Authorized ({{ request().totalCurrency }})</h5>
                        <span>{{
                            (request().totalAmountAuthorized | number: '1.2-2' : 'en-US') ?? 'Unspecified'
                        }}</span>
                    </div>
                }
                @let patientsCurrencyTotal = totalPatientsCurrencyAmount();
                @if (patientsCurrencyTotal) {
                    <div>
                        <h5 class="font-bold">{{ patientsCurrencyTotal.label }}</h5>
                        <span>{{ patientsCurrencyTotal.text }}</span>
                    </div>
                }
                @let usdTotal = totalUsdAmount();
                @if (usdTotal) {
                    <div>
                        <h5 class="font-bold">{{ usdTotal.label }}</h5>
                        <span>{{ usdTotal.text }}</span>
                    </div>
                }
            </div>
        }
        <div class="grid grid-cols-3 gap-medpace px-medpace">
            <div>
                <h5 class="font-bold">Transaction Date</h5>
                <span>{{
                    request().transactionDate
                        ? (request().transactionDate | dateFormat: undefined : 'local' | uppercase)
                        : 'Unspecified'
                }}</span>
            </div>
            <div>
                <h5 class="font-bold">Merchant</h5>
                <span>{{ (merchant$ | async)?.viewValue ?? 'Unspecified' }}</span>
            </div>
        </div>

        @let isVoided = isVoided$ | async;
        @if (isVoided) {
            <div>
                <medpace-payment-request-deduction-view
                    [amount]="request().deducted"
                    [amountConverted]="request().deductedUsd"
                    [currency]="request().deductedCurrency"
                />
            </div>
        }
    }
</div>
